<template>
  <div class="hyper-link-container">
    <el-dialog
        title="添加超链接"
        :visible.sync="show"
        @open="openHandle"
        @close="closeHandle"
        width="600px"
        append-to-body
    :before-close="closeHandle"
    :z-index="9999"
    >
    <div class="m-searchbar">
      <el-form :model="formData" label-width="120px" :rules="rules" ref="linkForm">
        <el-form-item label="超链接文本：" prop="text">
          <el-input v-model="formData.text" clearable placeholder="请输入超链接文本" maxlength="200"></el-input>
        </el-form-item>
        <el-form-item label="超链接地址：" prop="url">
          <el-input v-model="formData.url" clearable placeholder="请输入超链接地址" maxlength="200"></el-input>
        </el-form-item>
        <el-form-item label="选择文件">
          <el-upload
              class="upload-demo"
              drag
              action="#"
              :http-request="uploadFile"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div style=" text-align: center;">
        <el-button type="primary" size="mini" @click="confirm">确认</el-button>
        <el-button size="mini" @click="closeHandle">取消</el-button>
      </div>
    </div>
    </el-dialog>
  </div>
</template>

<script>
import { uploadFile } from "@/api/upload";

export default {
  name: 'InsertLink',
  props: {
    insertLinkName: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      show: this.visible,
      formData: {
        text: '',
        url: ''
      },
      rules: {
        text: [
          { required: true, message: '请输入超链接文本，最多输入40字', trigger: 'blur' }
        ],
        url: [
          { required: true, message: '请输入超链接地址', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    openHandle() {},
    closeHandle() {
      this.$emit('update:visible', false);
    },
    confirm() {
      this.$refs.linkForm.validate((valid) => {
        if (valid) {
          this.closeHandle();
          this.$emit('confirm', this.formData);
        } else {
          return false;
        }
      });
      this.$refs['linkForm'].resetFields();
    },
    uploadFile(file) {
      let formData = new FormData();
      formData.append("file", file.file);
      formData.append("returnUrl", true);
      uploadFile(formData).then((res) => {
        this.formData.url = res.data;
      });
    }
  },
  watch: {
    visible() {
      this.show = this.visible;
    },
    insertLinkName() {
      console.log("editor insertLinkName!", this.insertLinkName);
      this.formData.text = this.insertLinkName;
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
